import React from 'react'
import { Spinner } from 'react-bootstrap'

import '../../assets/style/ui/loading.css'

const Loading = () => {
  return (
    <div className='loading'>
        <Spinner animation="grow" variant="primary" />
    </div>
  )
}

export default Loading
